import type { FlightKey } from "@b2bportal/air-price-watch-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import {
  type UnwatchTripResponse,
  useUnwatchTripForm,
} from "./hooks/useUnwatchTripForm";

interface UnwatchTripViewProps {
  cn: (elementName: string) => string;
  flightKey: FlightKey;
  onSuccess?: (response: UnwatchTripResponse) => void;
  onError?: (error: unknown) => void;
}

export const UnwatchTripView = ({
  cn,
  flightKey,
  onSuccess,
  onError,
}: UnwatchTripViewProps): JSX.Element => {
  const { t } = useI18nContext();

  const {
    context: { isSubmitting },
    handlers: { onUnwatchTripSubmit },
  } = useUnwatchTripForm({
    flightKey,
    onSuccess,
    onError,
  });

  return (
    <div className={cn("unwatch-trip-view")}>
      <p className={cn("subtitle")}>{t("priceWatch.unwatchTitle")}</p>

      <p className={cn("description")}>{t("priceWatch.unwatchMessage")}</p>

      <div className={cn("form")}>
        <button
          className={clsx(cn("cta-button"), "cta-button")}
          onClick={onUnwatchTripSubmit}
          disabled={isSubmitting}
        >
          {t("priceWatch.stopWatchingButtonCta")}
        </button>
      </div>
    </div>
  );
};
